var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-box p-5" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.reset_sent === true
        ? _c(
            "div",
            { staticClass: "alert alert-info" },
            [
              _c("p", [
                _vm._v("A request to reset your password has been sent.")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "If your email exists in our database, you will receive instructions on how to reset your password."
                )
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "c-btn c-btn--success",
                  attrs: {
                    to: { name: "login.main", params: { company_id: _vm.c_id } }
                  }
                },
                [_vm._v("\n            Sign In\n        ")]
              )
            ],
            1
          )
        : [
            _c("div", { staticClass: "c-form" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.forgot_pass($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row form-group c-form__group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-12 c-form__label",
                        attrs: { for: "cId" }
                      },
                      [_vm._v("Panel Id")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("b-form-input", {
                          attrs: { id: "cId", placeholder: "" },
                          model: {
                            value: _vm.c_id,
                            callback: function($$v) {
                              _vm.c_id =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "c_id"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row form-group c-form__group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-12 c-form__label",
                        attrs: { for: "inputEmail1" }
                      },
                      [_vm._v("Email")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("b-form-input", {
                          attrs: { id: "inputEmail1", placeholder: "" },
                          model: {
                            value: _vm.email,
                            callback: function($$v) {
                              _vm.email =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "email"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row form-group c-form__group" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-offset-2 col-12" },
                      [
                        _vm.forgot_pass_in_progress === false
                          ? _c(
                              "button",
                              {
                                staticClass: "c-btn c-btn--success",
                                attrs: { type: "submit" }
                              },
                              [
                                _vm._v(
                                  "\n                            Reset password\n                        "
                                )
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "c-btn c-btn-default",
                                attrs: { disabled: "" }
                              },
                              [
                                _vm._v(
                                  "\n                            Loading...\n                        "
                                )
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "c-btn c-btn-default",
                            attrs: {
                              to: {
                                name: "login.main",
                                params: { company_id: _vm.c_id }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Sign In\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ],
      _vm._v(" "),
      _c("forgot-password-main-ccs-modal")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-box__header mb-5" }, [
      _c("div", { staticClass: "c-box__title text-center text-uppercase" }, [
        _vm._v("\n            Forgot Password\n        ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }